import React from "react";

export default function UIToggle({
   checked = false,
   onChange,
   disabled = false,
   className = "",
   "aria-label": ariaLabel,
}) {
   const isChecked = checked === true;

   return (
      <button
         type="button"
         role="switch"
         aria-checked={isChecked ? "true" : "false"}
         aria-label={ariaLabel}
         className={`uiToggle ${isChecked ? "is-on" : ""} ${className || ""}`.trim()}
         onClick={() => {
            if (disabled) return;
            onChange?.(!isChecked);
         }}
         disabled={disabled}
      >
         <span className="uiToggle__track" aria-hidden="true">
            <span className="uiToggle__thumb"></span>
         </span>
      </button>
   );
}
